










































import Vue from 'vue'

export default Vue.extend({
  name: 'TextArea',
  data: () => ({
    showCharacterWarning: false,
  }),
  props: {
    id: String,
    value: String,
    title: String,
    placeholder: {
      type: String,
      default: 'Type your message here...',
    },
    counterText: {
      type: String,
      required: true,
    },
    fieldName: String,
    disable: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      required: false,
    },
    rules: Array,
  },
  methods: {
    checkIfCharacterWarning: function () {
      if (this.value.length === this.maxlength) {
        this.showCharacterWarning = true
      }
    },
  },
})
